import React, { useEffect, useState } from 'react'
import { Button, Col, Pagination, Spinner, Table } from 'react-bootstrap'
import { MdHistory } from 'react-icons/md'
import { Title } from '../../../../Templates/Title'
import { getAllHistoryExport, getHistory } from '../../../API/History/History'
import { GetHistoryProps, HistoryItem } from '../../../API/History/models'
import { humanizeDate } from '../../../../Utils/Dates/Dates'
import { getBotUsers } from '../../../API/Users/Users'
import { HiOutlineDocumentDownload } from 'react-icons/hi'
import Swal from 'sweetalert2'
import { useExportHistory } from './hooks/useExportHistory'

export interface HistoryFiltersForm {
    targetName: string;
    startDate: string;
    endDate: string;
    creatorName: string;
    senderName: string;
    destinationAccountName: string;
    isPromotion: boolean;
}
const defaultPageSize = 30

export const History = () => {
    const today = new Date().toISOString().split('T')[0]
    const twoMonthsAgo = new Date(new Date().setMonth(new Date().getMonth() - 2)).toISOString().split('T')[0]

    const defaultFilters = {
        page: 1,
        pageSize: 30,
        targetName: '',
        startDate: twoMonthsAgo,
        endDate: today,
        creatorName: '',
        senderName: '',
        destinationAccountName: '',
        isPromotion: false
    }

    const [loading, setLoading] = useState(false)
    const [history, setHistory] = useState<HistoryItem[]>([])
    const [allCreatorsNames, setAllCreatorNames] = useState<string[]>([])

    // Pagination
    const [totalPages, setTotalPages] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)

    // Filters
    const [filters, setFilters] = useState<HistoryFiltersForm>({
        targetName: '',
        startDate: twoMonthsAgo,
        endDate: today,
        creatorName: '',
        senderName: '',
        destinationAccountName: '',
        isPromotion: false
    })

    const { fetchDataToExport, loadingExport } = useExportHistory({ filters })

    const getAllCreators = async () => {
        const response = await getBotUsers()
        if (response && Array.isArray(response)) {
            let allNames = response?.map(user => user.name)
            setAllCreatorNames(allNames)
        }
    }

    const fetchHistory = async ({ page = 1, pageSize = 15, targetName = filters?.targetName?.trim(), startDate = filters.startDate, endDate = filters.endDate, creatorName = filters.creatorName, senderName = filters.senderName, destinationAccountName = filters.destinationAccountName }: GetHistoryProps) => {
        setLoading(true)
        const res = await getHistory({ page, pageSize, targetName: targetName?.trim(), startDate, endDate, creatorName, senderName, destinationAccountName })
        if (res?.data) {
            setHistory(res.data)
            setTotalPages(res.totalPages)
            setCurrentPage(res.currentPage)
        }
        setLoading(false)
    }

    const handleSearch = () => {

        if (filters.startDate > filters.endDate) {
            Swal.fire({
                icon: 'error',
                text: 'La fecha de inicio no puede ser mayor a la fecha de fin'
            })
            return;
        }

        const startDate = new Date(filters.startDate);
        const endDate = new Date(filters.endDate);
        const diffYears = endDate.getFullYear() - startDate.getFullYear();
        const diffMonths = diffYears * 12 + (endDate.getMonth() - startDate.getMonth());
        console.log(diffMonths, 'diffMonths')
        if (diffMonths > 2) {
            Swal.fire({
                icon: 'error',
                text: 'La diferencia entre fecha de inicio y fecha de fin no puede ser mayor a 2 meses'
            })
            return;
        }


        fetchHistory({ ...filters, page: 1, pageSize: defaultPageSize })
    }


    const cleanFilters = () => {
        setFilters({ ...defaultFilters })
        fetchHistory({ ...defaultFilters })
    }

    const handlePageChange = (page: number) => {
        setCurrentPage(page)
        fetchHistory({ ...filters, page, pageSize: defaultPageSize })
    }


    useEffect(() => {
        fetchHistory({ ...defaultFilters })
        getAllCreators();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const renderPaginationItems = () => {
        const items = [];
        const startPage = Math.max(1, currentPage - 2);
        const endPage = Math.min(totalPages, currentPage + 2);

        // First page
        if (currentPage > 3) {
            items.push(
                <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
                    1
                </Pagination.Item>
            );
            items.push(<Pagination.Ellipsis key="ellipsis1" disabled />);
        }

        // Pages around current page
        for (let page = startPage; page <= endPage; page++) {
            items.push(
                <Pagination.Item
                    key={page}
                    active={currentPage === page}
                    onClick={() => handlePageChange(page)}
                >
                    {page}
                </Pagination.Item>
            );
        }

        // Last page
        if (currentPage < totalPages - 2) {
            items.push(<Pagination.Ellipsis key="ellipsis2" disabled />);
            items.push(
                <Pagination.Item
                    key={totalPages}
                    onClick={() => handlePageChange(totalPages)}
                >
                    {totalPages}
                </Pagination.Item>
            );
        }

        return items;
    };

    return (
        <div className='pb-5 mt-4'>
            <Title

                title="Historial"
                icon={<MdHistory size={30} />}
                subtitle="Registro de transacciones y actividades"
            />
            <Col md={12} sm={12} className='mx-auto'>

                <div className='mb-3 mt-5'>
                    <div className="d-flex align-items-end justify-content-between flex-wrap gap-3">


                        <div className='d-flex align-items-end justify-content-between flex-wrap gap-3'>
                            <div className="d-flex flex-column align-items-start">
                                <label htmlFor="target" className="text-white mb-1"><small>Usuario</small></label>
                                <input
                                    className='form-control px-3 rounded border-0 customDarkInput py-2'
                                    placeholder='Buscar por jugador'
                                    name='targetName'
                                    value={filters.targetName}
                                    onChange={(e) => setFilters({ ...filters, targetName: e.target.value })}
                                />
                            </div>

                            <div className="d-flex gap-2">
                                <div className="d-flex flex-column align-items-start">
                                    <label htmlFor="start" className="text-white mb-1"><small>Fecha inicio</small></label>
                                    <input
                                        value={filters.startDate}
                                        type="date"
                                        id="start"
                                        name="start"
                                        className="form-control text-white"
                                        onChange={(e) => setFilters({ ...filters, startDate: e.target.value })}
                                    />
                                </div>

                                <div className="d-flex flex-column align-items-start">
                                    <label htmlFor="end" className="text-white mb-1"><small>Fecha fin</small></label>
                                    <input
                                        value={filters.endDate}
                                        type="date"
                                        id="end"
                                        name="end"
                                        className="form-control text-white"
                                        onChange={(e) => setFilters({ ...filters, endDate: e.target.value })}
                                    />
                                </div>
                            </div>

                            <div>
                                <div className="d-flex flex-column align-items-start">
                                    <label htmlFor="creatorFilter" className="text-white mb-1"><small>Filtrar por cajero</small></label>
                                    <select
                                        id="creatorFilter"
                                        className="form-select px-4 rounded py-2"
                                        value={filters.creatorName}
                                        onChange={(e) => setFilters({ ...filters, creatorName: e.target.value })}
                                    >
                                        <option className='text-start' key={'todos'} value={''}>Todos</option>
                                        {allCreatorsNames.map((user, index) => (
                                            <option className='text-start' key={index} value={user}>{user}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="d-flex flex-column align-items-start">
                                <label htmlFor="target" className="text-white mb-1"><small>Remitente</small></label>
                                <input
                                    className='form-control px-3 rounded border-0 customDarkInput py-2'
                                    placeholder='Buscar por remitente'
                                    name='senderName'
                                    value={filters.senderName}
                                    onChange={(e) => setFilters({ ...filters, senderName: e.target.value })}
                                />
                            </div>


                            <div className="d-flex flex-column align-items-start">
                                <label htmlFor="target" className="text-white mb-1"><small>Destinatario</small></label>
                                <input
                                    className='form-control px-3 rounded border-0 customDarkInput py-2'
                                    placeholder='Buscar por destinatario'
                                    name='destinationAccountName'
                                    value={filters.destinationAccountName}
                                    onChange={(e) => setFilters({ ...filters, destinationAccountName: e.target.value })}
                                />
                            </div>


                            <div className="d-flex gap-2 align-items-end justify-content-end">
                                <Button
                                    variant='primary'
                                    onClick={handleSearch}
                                    className='text-nowrap'
                                >
                                    Buscar
                                </Button>
                                <Button
                                    variant='secondary'
                                    onClick={cleanFilters}
                                    className='text-nowrap'
                                >
                                    Limpiar filtros
                                </Button>
                            </div>
                        </div>



                        <div className="d-flex align-items-center justify-content-end">
                            <Button variant='success' disabled={loadingExport} className="d-flex align-items-center" onClick={fetchDataToExport}>
                                <HiOutlineDocumentDownload size={22} />
                                <div className="mx-1">
                                    {loadingExport ? 'Exportando...' : 'Exportar'}
                                </div>
                            </Button>
                        </div>


                    </div>
                </div>

                <div>
                    {loading &&
                        <div className='d-flex justify-content-center align-items-center flex-column text-primaryy' style={{ height: '20vh' }}>
                            <div className="mb-1">
                                Cargando página {currentPage}
                            </div>
                            <Spinner animation="border" variant="primary" />
                        </div>
                    }
                    {!loading && <div>
                        <Table striped bordered hover responsive>
                            <thead>
                                <tr>
                                    <th className='text-sm text-primary text-center'>Fecha</th>
                                    <th className='text-sm text-primary text-center'>Usuario</th>
                                    <th className='text-sm text-primary text-center'>Descripción</th>
                                    <th className='text-sm text-primary text-center'>Cuenta Remitente</th>
                                    <th className='text-sm text-primary text-center'>Cuenta Destinatario</th>
                                    <th className='text-sm text-primary text-center'>En Promoción</th>


                                </tr>
                            </thead>
                            <tbody>
                                {history.map((row) => (
                                    <tr key={row.id}>
                                        <td className='text-sm text-secondary text-center'>{humanizeDate(row.date)}</td>
                                        <td className='text-sm text-primary text-center'>{row.creator}</td>
                                        <td className='text-sm text-primary text-center'>{row.description}</td>
                                        <td className='text-sm text-secondary text-center'>{row.senderName}</td>
                                        <td className='text-sm text-secondary text-center'>{row.destinationAccountName}</td>
                                        <td className='text-sm text-secondary text-center'>{row.currentInPromo ? 'Si' : ''}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <div className='d-flex justify-content-center'>
                            <Pagination>
                                <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                                <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                                {renderPaginationItems()}
                                <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
                                <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
                            </Pagination>
                        </div>
                    </div>}
                </div>
            </Col>
        </div >

    )
}
